import items from './items';
import store from './store';
import show from './show';
import update from './update';
import all from './all';

export default {
  items,
  store,
  show,
  update,
  all,
};




// WEBPACK FOOTER //
// ./src/app/services/productTag/index.js